<template>
  <div class="u-notice">
    <page-nav :nav-list="navList" />
    <div class="content">
      <news-list :prop-list="listData" :list-number="listNumber" />
    </div>
  </div>
</template>

<script>
import PageNav from '@/components/pageNav'
import NewsList from '@/components/newsList'
import { searchNews } from '@/apis/user'
import { mapState } from 'vuex'

export default {
  components: {
    PageNav,
    NewsList
  },
  data() {
    return {
      page: 1,
      total: 0,
      listData: [],
      navList: ['新闻列表'],
      listNumber: 10
    }
  },
  computed: {
    ...mapState({
      newsName: (state) => state.news.newsName

    })
  },
  watch: {
    newsName() {
      this.getItems()
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    async getItems() {
      const params = {
        title: this.newsName
      }
      const data = await searchNews({ params })
      this.listData = data.data.newsLists
      this.listNumber = Math.max(10, data.data.newsLists.length)
    }
  }
}
</script>

<style lang="scss" scoped>
  .u-notice{
    padding: 0 10px;
    .content{
      width: 90%;
      margin: 20px auto;
      overflow: hidden;
      padding-bottom: 40px;
    }
  }
</style>
